import { TENANTS } from "../../../constants"

function isStepVisible(breadcrumb) {
  return breadcrumb.hasOwnProperty("title") && breadcrumb.title && breadcrumb.hidden !== true
}

function getPreviousVisibleStepId(breadcrumbs, currentStepId) {
  const currentIndex = breadcrumbs.findIndex((b) => b.id === currentStepId)
  if (currentIndex <= 0) return null
  for (let i = currentIndex - 1; i >= 0; i--) {
    if (isStepVisible(breadcrumbs[i])) return breadcrumbs[i].id
  }
  return null
}

export function useHeader(tunnelData) {
  const { tenant, breadcrumbs, step } = tunnelData
  let currentStepNumber = null
  let description = ""
  let titleReassurance = ""
  let reassuranceInformationPage = ""
  let reassuranceInformationPageItalic = " "
  let reassuranceRecapPage = ""

  // Only steps with "title" and not hidden are shown in breadcrumbs; numbering is based on visible steps only.
  const customerJourneyBreadcrumbs = breadcrumbs.filter(isStepVisible)
  const currentStepDef = breadcrumbs.find((b) => b.id === step)
  const isCurrentStepHidden = currentStepDef?.hidden === true
  const effectiveStepId = isCurrentStepHidden ? getPreviousVisibleStepId(breadcrumbs, step) : step
  const currentBreadcrumb = effectiveStepId
    ? customerJourneyBreadcrumbs.find((breadcrumb) => breadcrumb.id === effectiveStepId)
    : null

  if (currentBreadcrumb) {
    description = currentBreadcrumb.title
    currentStepNumber = customerJourneyBreadcrumbs.indexOf(currentBreadcrumb) + 1
  }

  if (tenant === TENANTS.BPLS) {
    if (step === "stepClient") {
      description = "Complétez vos informations"
      titleReassurance = "Votre demande de location financière"
      reassuranceInformationPage =
        "Afin de finaliser votre commande, merci de vérifier les informations saisies, et si besoin compléter les champs vides. "
      reassuranceInformationPageItalic =
        "Si vous souhaitez modifier des données figées, il faut vous rendre directement sur votre compte Samsung."
    } else if (step === "stepSummary") {
      description = "Soumettez votre demande de location"
      titleReassurance = "Votre demande de location financière"
      reassuranceRecapPage =
        "Merci de vérifier les informations relatives à votre demande de location financière avant de soumettre votre demande."
    }
  }

  return {
    breadcrumbs,
    displayBreadcrumbs: customerJourneyBreadcrumbs,
    step,
    effectiveStepId: effectiveStepId ?? step,
    currentStepNumber,
    description,
    titleReassurance,
    reassuranceInformationPage,
    reassuranceInformationPageItalic,
    reassuranceRecapPage
  }
}
